
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35161',
  depVersions: {
  "documents-public-ui": "static-1.35161",
  "atom": "static-1.5350",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2759",
  "client-types": "static-1.496",
  "cssUtils": "static-1.883",
  "customer-data-filters-ui": "static-1.40808",
  "customer-data-objects": "static-1.7952",
  "customer-data-property-utils": "static-1.8366",
  "documents-lib": "static-1.35166",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.363",
  "FormsCommonComponents": "static-1.86500",
  "FormUrlGenerator": "static-2.4992",
  "foundations-theming-specialty": "static-1.2450",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.108",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5861",
  "hs-test-utils": "static-1.8294",
  "hub-http": "static-1.6478",
  "hubspot-dlb": "static-2.1882",
  "HubStyle": "static-2.12056",
  "HubStyleTokens": "static-2.11749",
  "I18n": "static-7.1666",
  "icons": "static-2.676",
  "jasmine-immutable": "static-1.3287",
  "jasmine-runner": "static-1.6717",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7417",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3159",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5663",
  "quartz": "static-1.7408",
  "react": "static-7.192",
  "react-dlb": "static-1.88",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1-feat-wv-soft-nav-lcp.10",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5532",
  "react-virtualized": "static-2.104",
  "reference-resolvers": "static-1.8447",
  "reference-resolvers-lite": "static-1.8367",
  "reporting-data": "static-1.68678",
  "reporting-reports": "static-1.68355",
  "reporting-snowflake": "static-1.57295",
  "reporting-testing-lib": "static-1.10611",
  "reporting-visualizations": "static-1.60753",
  "reselect": "static-3.9",
  "sales-content-partitioning": "static-1.9216",
  "sanitize": "static-1.4739",
  "sanitize-text": "static-1.8418",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.2012",
  "signup-constants": "static-1.19548",
  "signup-ui-url-generator": "static-2.8325",
  "StyleGuideUI": "static-3.498",
  "superstore": "static-1.5023",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.5021",
  "ui-addon-form-validation": "static-1.11248",
  "ui-asset-management-lib": "static-1.11361",
  "ui-images": "static-2.1236",
  "UIComponents": "static-3.8695",
  "usage-tracker": "static-1.7620",
  "usage-tracker-container": "static-1.7610",
  "usage-tracker-core": "static-1.7470",
  "viral-links-lib": "static-1.7340",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9924",
  "foundations-components": "static-1-ech-accordiontransition-jank.18",
  "immutable": "static-2.83",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1186",
  "quartz-core": "static-1.6627",
  "quick-fetch": "static-1.4108",
  "raven": "static-3.5925",
  "redux": "static-4.76",
  "redux-thunk": "static-2.77",
  "rpc-client-utils": "static-1.4928",
  "ui-addon-i18n": "static-1.11410",
  "ui-addon-upgrades": "static-9.18339",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3593",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3685",
  "quartz-webpack": "static-1.3632",
  "foundations-assets": "static-1.5146",
  "foundations-theming": "static-1.4734",
  "hub-http-janus": "static-1.872",
  "hub-http-shared-msw-handlers": "static-1.10561",
  "hubspotter-http": "static-1.4840",
  "sassPrefix": "static-1.163",
  "conversations-skeleton-state": "static-1.7512",
  "crm-message-bus": "static-1.43684",
  "customer-data-filters-ui-msw-helpers": "static-1.23243",
  "customer-data-objects-ui-components": "static-1.13295",
  "customer-data-reference-ui-components": "static-1.13444",
  "customer-data-ui-utilities": "static-1.10094",
  "events-data-lib": "static-1.506",
  "framework-builder-read-service-client": "static-1.4198",
  "hs-resources": "static-1.455",
  "immer": "static-1.94",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.4032",
  "multi-account-reference-resolvers": "static-1.1264",
  "onboarding-scopes": "static-1.6718",
  "onboarding-tours": "static-1.17068",
  "pulse": "static-1.891",
  "reporting-datasets-permissions-lib": "static-1.14404",
  "stylex": "static-1.38",
  "trellis-assets": "static-1.2539",
  "trellis-components": "static-1.2558",
  "trellis-theming": "static-1.1232",
  "ui-addon-teams": "static-1.21871",
  "quartz-auth": "static-1.1083",
  "ui-business-units-lib": "static-1.9350",
  "usage-tracker-session-replay": "static-1.5306",
  "ai-components-ui-library": "static-1.9641",
  "ContentUtils": "static-1.69063",
  "customer-data-properties": "static-1.52487",
  "forms-ai-lib": "static-1.4718",
  "forms-utils-lib": "static-1.13046",
  "foundations-components-test-utils": "static-1-ech-accordiontransition-jank.18",
  "react-dnd-compat": "static-1.4882",
  "react-tinymce": "static-1.55916",
  "tinymce-config": "static-2.55042",
  "ui-gdpr-components": "static-1.10621",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3719",
  "HeadJS": "static-2.792",
  "framer-motion": "static-1.76",
  "hs-test-utils-bend-plugin": "static-1.3405",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "hs-locale-management": "static-1.269",
  "ui-fonts": "static-1.1011",
  "i18n-data": "static-1.228",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4579",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1073",
  "web-vitals": "static-1.11",
  "batch-promise": "static-1.1808",
  "external-options-client-types": "static-1.4315",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7158",
  "quartz-i18n": "static-1.1083",
  "frontend-preferences-client": "static-1.8190",
  "graphql": "static-1.86",
  "persist-promise": "static-1.3965",
  "reporting-client-types": "static-1.2658",
  "apollo-stack-hubspot": "static-3.90",
  "growth-payments-core": "static-1.26114",
  "hubspot-apollo-client": "static-1.5144",
  "foundations-components-legacy": "static-1-ech-accordiontransition-jank.18",
  "quartz-routing": "static-1.838",
  "hs-story-utils": "static-1.9691",
  "react-flip-move": "static-1.75",
  "nested-table": "static-1.498",
  "seat-types-lib": "static-1.658",
  "timezone-utils": "static-2.5509",
  "react-create-root-preference": "static-1.65",
  "bend-plugin-foundations-components": "static-1-ech-accordiontransition-jank.18",
  "floating-ui": "static-1.62",
  "react-aria": "static-1.70",
  "tanstack-table": "static-1.59",
  "opentelemetry-fe-types": "static-1.33",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.572",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.408",
  "quartz-test": "static-1.1083",
  "quartz-tracking": "static-1.787",
  "bend-plugin-chirp-manifest": "static-1.338",
  "chirp-fetch": "static-1.2159",
  "merchandise-lib": "static-1.275",
  "purchase-motions-components": "static-1.6306",
  "salesImages": "static-1.532",
  "ts-schema": "static-1.4269",
  "bender-build-tools": "static-1.3406",
  "bend-plugin-foundations-theming": "static-1.3217",
  "restore-request-side-panel-lib": "static-1.1603",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.4920",
  "conditional-properties-service-client": "static-1.3988",
  "crm-pipelines-api-client-types": "static-1.4324",
  "event-emitter": "static-1.1219",
  "fdsr-migration-layer": "static-1.277",
  "multi-currency-client-types": "static-1.3885",
  "getting-started-shared-tasks": "static-1.19163",
  "growth-data-modal": "static-1.5847",
  "growth-onboarding-confetti": "static-1.3328",
  "growth-onboarding-next-action-utils": "static-1.2633",
  "navigation-components": "static-1.18752",
  "onboarding-tours-client": "static-1.5282",
  "onboarding-tours-utils": "static-1.1134",
  "ui-shepherd-react": "static-3.10531",
  "ui-shepherd-tracker": "static-1.7912",
  "ui-universal-auth": "static-1.9333",
  "user-context": "static-1.5382",
  "bend-plugin-pulse": "static-1.394",
  "fast-json-patch": "static-1.67",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "tanstack-virtual": "static-1.36",
  "hubspotter-http-shared-msw-handlers": "static-1.10559",
  "magpie-lib": "static-1.5731",
  "navigation-messaging": "static-1.8079",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.22758",
  "copilot-toolkit": "static-1.11785",
  "cms-field-types": "static-1.5078",
  "content-icons-ui": "static-1.2328",
  "integrations-lib": "static-1.16969",
  "calling-global-api": "static-1.65466",
  "calling-internal-common": "static-1.31583",
  "calling-lifecycle-internal": "static-1.66848",
  "calling-lifecycle-messages": "static-1.59142",
  "commerce-products-lib": "static-1.10458",
  "crm-index-visualization-core": "static-1.4499",
  "crm-links": "static-1.6594",
  "customer-data-properties-shared-msw-handlers": "static-1.9888",
  "file-manager-components": "static-1.24407",
  "formula-editor": "static-1.14701",
  "google-libphonenumber": "static-1.42",
  "inbounddb-objects-service-types": "static-1.4401",
  "meetings-icalendar-utils-lib": "static-1.900",
  "object-builder-ui-client": "static-1.49590",
  "pipeline-validation-client-types": "static-1.4158",
  "property-value-citations": "static-1.3101",
  "smart-data-capture-core": "static-1.66",
  "smart-property-lib": "static-1.8219",
  "tiered-pricing": "static-1.1903",
  "topics-actions-lib": "static-1.429",
  "trial-components-library": "static-1.14054",
  "ui-addon-iframeable": "static-1.9339",
  "zustand": "static-1.79",
  "final-form": "static-1.75",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.75",
  "rich-text-lib": "static-1.20259",
  "tinymce-themes": "static-1.57012",
  "data-token-picker": "static-1.16839",
  "hub-http-contrib": "static-1.3303",
  "interframe": "static-3.5021",
  "tinymce-data": "static-1.41127",
  "tinymce-plugins": "static-1.58156",
  "ui-addon-sales-email": "static-1.5478",
  "framework-data-schema-quick-fetch": "static-1.7063",
  "ui-addon-opt": "static-4.8629",
  "hubspot-apollo-cache": "static-1.603",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.426",
  "opentelemetry-web": "static-1.11",
  "purchase-motions-api": "static-1.6309",
  "onboarding-data-sync-lib": "static-1.2445",
  "growth-onboarding-next-action-components": "static-1.2661",
  "user-context-client": "static-1.4775",
  "idb-keyval": "static-1.48",
  "magpie-types": "static-1.5191",
  "nest": "static-1.501",
  "reactive-lib": "static-1.985",
  "simple-logging-lib": "static-1.3315",
  "unified-auth-core-lib": "static-1.1129",
  "getting-started-shared-tasks-store": "static-1.18281",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1623",
  "integrations-error-boundary-lib": "static-1.14384",
  "integrations-tracking-lib": "static-1.5871",
  "native-integrations-shared-strings": "static-1.8043",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10634",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.847",
  "calling-error-reporting": "static-1.31590",
  "shared-worker-versioning": "static-1.11306",
  "calling-usage-tracker": "static-1.6802",
  "voice-sms-access-library": "static-1.1956",
  "customer-data-tracking": "static-1.7146",
  "commerce-permissions": "static-1.1042",
  "products-iframe-lib": "static-1.8531",
  "products-ui-components-shared-msw-handlers": "static-1.10943",
  "crm-index-associations-lib": "static-1.6706",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10644",
  "sales-views-client-types": "static-1.4519",
  "location-customization-utils-lib": "static-1.10031",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4416",
  "video-components-external": "static-1.12095",
  "video-data-lib": "static-1.35753",
  "bark-lib": "static-1.16774",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.99",
  "crm-properties-common-lib": "static-1.6153",
  "react-codemirror": "static-1.10903",
  "data-agent-kit": "static-1.599",
  "feedback-loader": "static-1.29762",
  "fsm": "static-1.4009",
  "policy-lib": "static-1.7062",
  "react-colorpicker": "static-2.10472",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10707",
  "embedded-academy-lib": "static-1.15429",
  "hubs-service-types": "static-1.1522",
  "FileManagerLib": "static-1.40047",
  "NamespacedHubStyle": "static-2.9238",
  "FileManagerCore": "static-1.39906",
  "content-assistance-lib": "static-1.8156",
  "layout-dnd-components": "static-1.12916",
  "layout-dnd-utils": "static-1.11891",
  "ui-addon-emoji-picker": "static-1.10151",
  "ui-brand-identity-lib": "static-1.16330",
  "InboxConnectUtils": "static-4.15494",
  "meetings-connect-utils-lib": "static-1.7873",
  "breeze-engine-chat-components": "static-1.601",
  "breeze-engine-core": "static-1.901",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "universal-page-editor-lib": "static-1.3271",
  "adobe-sign-auth-lib": "static-1.392",
  "ads-unified-auth-lib": "static-1.1177",
  "google-sheets-integration-lib": "static-1.967",
  "microsoft-drive-auth-lib": "static-1.66",
  "surveymonkey-integration-lib": "static-1.412",
  "slack-ui-library": "static-1.10663",
  "calling-orchestration-schema": "static-1.36733",
  "crm-record-cards-service-types": "static-1.3759",
  "content-media-composition-data-lib": "static-1.13169",
  "content-media-compositions": "static-2.17176",
  "media-bridge-lib": "static-1.19360",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16303",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4774",
  "storybook-react": "static-1.37",
  "academy-common-lib": "static-1.14889",
  "audio-components": "static-1.6295",
  "FileManagerImages": "static-1.37558",
  "video-components": "static-1.14097",
  "breeze-artifacts-sdk": "static-1.239",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4798",
  "video-embed": "static-1.36587",
  "ui-addon-video-player": "static-1.8968",
  "ui-coaching-tips": "static-1.29250",
  "ContentData": "static-1.69138",
  "layout-data-lib": "static-1.10216",
  "academy-service-client": "static-1.3953",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4669",
  "trellis-ecosystem": "static-1.7584",
  "ui-addon-react-router-dom": "static-1.9802",
  "wootric-nps": "static-1.7176",
  "social-insights-client-types": "static-1.22685",
  "outpost": "static-1.4423",
  "growth-onboarding-feedback-components": "static-1.6849",
  "advanced-menus-core": "static-1.15532",
  "advanced-menus-lib": "static-1.12410",
  "ExportDialog": "static-6.10643",
  "ui-memberships-settings-lib": "static-1.34780",
  "marketplace-ui-apps-core": "static-1.19177",
  "marketplace-ui-common": "static-1.20645",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15531",
  "simple-menus-lib": "static-1.17048",
  "developer-experience-shared-components": "static-1.10768",
  "immutable-less": "static-1.4915",
  "marketplace-ui-client-types": "static-1.18052",
  "ui-addon-integrations-directory-panel": "static-2.8290",
  "ui-extensibility-client-types": "static-1.4183",
  "ai-settings-ui-library": "static-1.8276",
  "nav-meta": "static-1.30389",
  "ui-product-approvals-common": "static-1.933",
  "apps-service-types": "static-1.4006",
  "oauth-service-types": "static-1.4507",
  "simple-data-table": "static-1.3472"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35161",
  "atom": "/atom/static-1.5350",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2759",
  "client-types": "/client-types/static-1.496",
  "cssUtils": "/cssUtils/static-1.883",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40808",
  "customer-data-objects": "/customer-data-objects/static-1.7952",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8366",
  "documents-lib": "/documents-lib/static-1.35166",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.363",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86500",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4992",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2450",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.108",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5861",
  "hs-test-utils": "/hs-test-utils/static-1.8294",
  "hub-http": "/hub-http/static-1.6478",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyle": "/HubStyle/static-2.12056",
  "HubStyleTokens": "/HubStyleTokens/static-2.11749",
  "I18n": "/I18n/static-7.1666",
  "icons": "/icons/static-2.676",
  "jasmine-immutable": "/jasmine-immutable/static-1.3287",
  "jasmine-runner": "/jasmine-runner/static-1.6717",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7417",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3159",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5663",
  "quartz": "/quartz/static-1.7408",
  "react": "/react/static-7.192",
  "react-dlb": "/react-dlb/static-1.88",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1-feat-wv-soft-nav-lcp.10",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5532",
  "react-virtualized": "/react-virtualized/static-2.104",
  "reference-resolvers": "/reference-resolvers/static-1.8447",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8367",
  "reporting-data": "/reporting-data/static-1.68678",
  "reporting-reports": "/reporting-reports/static-1.68355",
  "reporting-snowflake": "/reporting-snowflake/static-1.57295",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10611",
  "reporting-visualizations": "/reporting-visualizations/static-1.60753",
  "reselect": "/reselect/static-3.9",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9216",
  "sanitize": "/sanitize/static-1.4739",
  "sanitize-text": "/sanitize-text/static-1.8418",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2012",
  "signup-constants": "/signup-constants/static-1.19548",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8325",
  "StyleGuideUI": "/StyleGuideUI/static-3.498",
  "superstore": "/superstore/static-1.5023",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5021",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11248",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11361",
  "ui-images": "/ui-images/static-2.1236",
  "UIComponents": "/UIComponents/static-3.8695",
  "usage-tracker": "/usage-tracker/static-1.7620",
  "usage-tracker-container": "/usage-tracker-container/static-1.7610",
  "usage-tracker-core": "/usage-tracker-core/static-1.7470",
  "viral-links-lib": "/viral-links-lib/static-1.7340",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9924",
  "foundations-components": "/foundations-components/static-1-ech-accordiontransition-jank.18",
  "immutable": "/immutable/static-2.83",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1186",
  "quartz-core": "/quartz-core/static-1.6627",
  "quick-fetch": "/quick-fetch/static-1.4108",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.76",
  "redux-thunk": "/redux-thunk/static-2.77",
  "rpc-client-utils": "/rpc-client-utils/static-1.4928",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11410",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18339",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3593",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3685",
  "quartz-webpack": "/quartz-webpack/static-1.3632",
  "foundations-assets": "/foundations-assets/static-1.5146",
  "foundations-theming": "/foundations-theming/static-1.4734",
  "hub-http-janus": "/hub-http-janus/static-1.872",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10561",
  "hubspotter-http": "/hubspotter-http/static-1.4840",
  "sassPrefix": "/sassPrefix/static-1.163",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7512",
  "crm-message-bus": "/crm-message-bus/static-1.43684",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23243",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13295",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13444",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10094",
  "events-data-lib": "/events-data-lib/static-1.506",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4198",
  "hs-resources": "/hs-resources/static-1.455",
  "immer": "/immer/static-1.94",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4032",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1264",
  "onboarding-scopes": "/onboarding-scopes/static-1.6718",
  "onboarding-tours": "/onboarding-tours/static-1.17068",
  "pulse": "/pulse/static-1.891",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14404",
  "stylex": "/stylex/static-1.38",
  "trellis-assets": "/trellis-assets/static-1.2539",
  "trellis-components": "/trellis-components/static-1.2558",
  "trellis-theming": "/trellis-theming/static-1.1232",
  "ui-addon-teams": "/ui-addon-teams/static-1.21871",
  "quartz-auth": "/quartz-auth/static-1.1083",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9350",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5306",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9641",
  "ContentUtils": "/ContentUtils/static-1.69063",
  "customer-data-properties": "/customer-data-properties/static-1.52487",
  "forms-ai-lib": "/forms-ai-lib/static-1.4718",
  "forms-utils-lib": "/forms-utils-lib/static-1.13046",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-ech-accordiontransition-jank.18",
  "react-dnd-compat": "/react-dnd-compat/static-1.4882",
  "react-tinymce": "/react-tinymce/static-1.55916",
  "tinymce-config": "/tinymce-config/static-2.55042",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10621",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3719",
  "HeadJS": "/HeadJS/static-2.792",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3405",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "hs-locale-management": "/hs-locale-management/static-1.269",
  "ui-fonts": "/ui-fonts/static-1.1011",
  "i18n-data": "/i18n-data/static-1.228",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4579",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1073",
  "web-vitals": "/web-vitals/static-1.11",
  "batch-promise": "/batch-promise/static-1.1808",
  "external-options-client-types": "/external-options-client-types/static-1.4315",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7158",
  "quartz-i18n": "/quartz-i18n/static-1.1083",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8190",
  "graphql": "/graphql/static-1.86",
  "persist-promise": "/persist-promise/static-1.3965",
  "reporting-client-types": "/reporting-client-types/static-1.2658",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.90",
  "growth-payments-core": "/growth-payments-core/static-1.26114",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5144",
  "foundations-components-legacy": "/foundations-components-legacy/static-1-ech-accordiontransition-jank.18",
  "quartz-routing": "/quartz-routing/static-1.838",
  "hs-story-utils": "/hs-story-utils/static-1.9691",
  "react-flip-move": "/react-flip-move/static-1.75",
  "nested-table": "/nested-table/static-1.498",
  "seat-types-lib": "/seat-types-lib/static-1.658",
  "timezone-utils": "/timezone-utils/static-2.5509",
  "react-create-root-preference": "/react-create-root-preference/static-1.65",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-ech-accordiontransition-jank.18",
  "floating-ui": "/floating-ui/static-1.62",
  "react-aria": "/react-aria/static-1.70",
  "tanstack-table": "/tanstack-table/static-1.59",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.33",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.572",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.408",
  "quartz-test": "/quartz-test/static-1.1083",
  "quartz-tracking": "/quartz-tracking/static-1.787",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.338",
  "chirp-fetch": "/chirp-fetch/static-1.2159",
  "merchandise-lib": "/merchandise-lib/static-1.275",
  "purchase-motions-components": "/purchase-motions-components/static-1.6306",
  "salesImages": "/salesImages/static-1.532",
  "ts-schema": "/ts-schema/static-1.4269",
  "bender-build-tools": "/bender-build-tools/static-1.3406",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3217",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1603",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4920",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3988",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4324",
  "event-emitter": "/event-emitter/static-1.1219",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.277",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3885",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19163",
  "growth-data-modal": "/growth-data-modal/static-1.5847",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3328",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2633",
  "navigation-components": "/navigation-components/static-1.18752",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5282",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1134",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10531",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7912",
  "ui-universal-auth": "/ui-universal-auth/static-1.9333",
  "user-context": "/user-context/static-1.5382",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.394",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10559",
  "magpie-lib": "/magpie-lib/static-1.5731",
  "navigation-messaging": "/navigation-messaging/static-1.8079",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.22758",
  "copilot-toolkit": "/copilot-toolkit/static-1.11785",
  "cms-field-types": "/cms-field-types/static-1.5078",
  "content-icons-ui": "/content-icons-ui/static-1.2328",
  "integrations-lib": "/integrations-lib/static-1.16969",
  "calling-global-api": "/calling-global-api/static-1.65466",
  "calling-internal-common": "/calling-internal-common/static-1.31583",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66848",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59142",
  "commerce-products-lib": "/commerce-products-lib/static-1.10458",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4499",
  "crm-links": "/crm-links/static-1.6594",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9888",
  "file-manager-components": "/file-manager-components/static-1.24407",
  "formula-editor": "/formula-editor/static-1.14701",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4401",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.900",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49590",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4158",
  "property-value-citations": "/property-value-citations/static-1.3101",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.66",
  "smart-property-lib": "/smart-property-lib/static-1.8219",
  "tiered-pricing": "/tiered-pricing/static-1.1903",
  "topics-actions-lib": "/topics-actions-lib/static-1.429",
  "trial-components-library": "/trial-components-library/static-1.14054",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9339",
  "zustand": "/zustand/static-1.79",
  "final-form": "/final-form/static-1.75",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "rich-text-lib": "/rich-text-lib/static-1.20259",
  "tinymce-themes": "/tinymce-themes/static-1.57012",
  "data-token-picker": "/data-token-picker/static-1.16839",
  "hub-http-contrib": "/hub-http-contrib/static-1.3303",
  "interframe": "/interframe/static-3.5021",
  "tinymce-data": "/tinymce-data/static-1.41127",
  "tinymce-plugins": "/tinymce-plugins/static-1.58156",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5478",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7063",
  "ui-addon-opt": "/ui-addon-opt/static-4.8629",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.603",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.426",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "purchase-motions-api": "/purchase-motions-api/static-1.6309",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2445",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2661",
  "user-context-client": "/user-context-client/static-1.4775",
  "idb-keyval": "/idb-keyval/static-1.48",
  "magpie-types": "/magpie-types/static-1.5191",
  "nest": "/nest/static-1.501",
  "reactive-lib": "/reactive-lib/static-1.985",
  "simple-logging-lib": "/simple-logging-lib/static-1.3315",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1129",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18281",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1623",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14384",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5871",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8043",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10634",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.847",
  "calling-error-reporting": "/calling-error-reporting/static-1.31590",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11306",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6802",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1956",
  "customer-data-tracking": "/customer-data-tracking/static-1.7146",
  "commerce-permissions": "/commerce-permissions/static-1.1042",
  "products-iframe-lib": "/products-iframe-lib/static-1.8531",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10943",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6706",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10644",
  "sales-views-client-types": "/sales-views-client-types/static-1.4519",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10031",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4416",
  "video-components-external": "/video-components-external/static-1.12095",
  "video-data-lib": "/video-data-lib/static-1.35753",
  "bark-lib": "/bark-lib/static-1.16774",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.99",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6153",
  "react-codemirror": "/react-codemirror/static-1.10903",
  "data-agent-kit": "/data-agent-kit/static-1.599",
  "feedback-loader": "/feedback-loader/static-1.29762",
  "fsm": "/fsm/static-1.4009",
  "policy-lib": "/policy-lib/static-1.7062",
  "react-colorpicker": "/react-colorpicker/static-2.10472",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10707",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15429",
  "hubs-service-types": "/hubs-service-types/static-1.1522",
  "FileManagerLib": "/FileManagerLib/static-1.40047",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9238",
  "FileManagerCore": "/FileManagerCore/static-1.39906",
  "content-assistance-lib": "/content-assistance-lib/static-1.8156",
  "layout-dnd-components": "/layout-dnd-components/static-1.12916",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11891",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10151",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16330",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15494",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7873",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.601",
  "breeze-engine-core": "/breeze-engine-core/static-1.901",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3271",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.392",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1177",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.967",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.66",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.412",
  "slack-ui-library": "/slack-ui-library/static-1.10663",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36733",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3759",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13169",
  "content-media-compositions": "/content-media-compositions/static-2.17176",
  "media-bridge-lib": "/media-bridge-lib/static-1.19360",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16303",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4774",
  "storybook-react": "/storybook-react/static-1.37",
  "academy-common-lib": "/academy-common-lib/static-1.14889",
  "audio-components": "/audio-components/static-1.6295",
  "FileManagerImages": "/FileManagerImages/static-1.37558",
  "video-components": "/video-components/static-1.14097",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.239",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4798",
  "video-embed": "/video-embed/static-1.36587",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8968",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29250",
  "ContentData": "/ContentData/static-1.69138",
  "layout-data-lib": "/layout-data-lib/static-1.10216",
  "academy-service-client": "/academy-service-client/static-1.3953",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4669",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7584",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9802",
  "wootric-nps": "/wootric-nps/static-1.7176",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "outpost": "/outpost/static-1.4423",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6849",
  "advanced-menus-core": "/advanced-menus-core/static-1.15532",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12410",
  "ExportDialog": "/ExportDialog/static-6.10643",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34780",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19177",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20645",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15531",
  "simple-menus-lib": "/simple-menus-lib/static-1.17048",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10768",
  "immutable-less": "/immutable-less/static-1.4915",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18052",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8290",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4183",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8276",
  "nav-meta": "/nav-meta/static-1.30389",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.933",
  "apps-service-types": "/apps-service-types/static-1.4006",
  "oauth-service-types": "/oauth-service-types/static-1.4507",
  "simple-data-table": "/simple-data-table/static-1.3472"
}
};
